const handleDeleteUserFormParamUser = {
  confirm: 'Do you really want to delete this contributor?',
  title: 'DELETE COLLABORATOR'
};

export default handleDeleteUserFormParamUser;
